import { at } from "./at.js";

export const elementAt = at;